import React from "react"
import { NavLink, NavLinkProps } from "react-router-dom"

import { PageWrapper } from "@components/page-wrapper"
import { AuthCard } from "../../auth/styles"

import Stack from "@mui/material/Stack"
import Box from "@mui/material/Box"
import styled from "@mui/material/styles/styled"

import FirstTimeOnboardingController from "../../../packages/features/first-time-onboarding/first-time-onboarding-controller"

interface LinkProps extends NavLinkProps {
  current: string
}

interface ExternalPageProps {
  showOnboarding?: any
  presenter?: "general" | "partner" | "none"
  children: any
}

const TopNavBar = styled(Box)(
  ({ theme }) => `
    display: relative;
    height: max-content;
    width: 100%;
    padding: 12px 12px;
    align-items: center;
    background-color: ${theme.palette.background.default};
    border-bottom: 1px solid ${theme.palette.divider};
  `
)

const Link = styled(NavLink)<LinkProps>(
  ({ theme, current }) => `
  text-decoration: none;
  font-size: 0.8rem;
  font-weight: 700;
  color: ${theme.palette.grey[500]};

  &:hover {
    color: ${theme.palette.primary.main};
  }

  &:active {
    color: ${theme.palette.primary.main};
  }

  ${
    current === "true"
      ? `
  color: ${theme.palette.primary.main};
  `
      : ""
  }
`
)

const generalNav = ({ getPath }: any) => (
  <Stack direction="row" gap={1} justifyContent="center">
    <Link to="/" current={getPath("/")}>
      Login
    </Link>
    |
    <Link to="/signup" current={getPath("/signup")}>
      Sign up
    </Link>
    |
    <Link to="/pricing" current={getPath("/pricing")}>
      Pricing
    </Link>
    |
    <Link
      to="/frequently-asked-questions"
      current={getPath("/frequently-asked-questions")}
    >
      FAQs
    </Link>
    |
    <Link to="/terms" current={getPath("/terms")}>
      Terms
    </Link>
  </Stack>
)

const partnerNav = ({ getPath }: any) => (
  <Stack direction="row" gap={1} justifyContent="center">
    <Link to="/finapi/login" current={getPath("/finapi/login")}>
      Login
    </Link>
    |
    <Link to="/finapi/api_docs" current={getPath("/finapi/api_docs")}>
      API Docs
    </Link>
    |
    <Link to="/pricing" current={getPath("/pricing")}>
      Pricing
    </Link>
  </Stack>
)

const componentMap = {
  general: generalNav,
  partner: partnerNav,
  none: () => null,
}

export const ExternalPage = ({
  showOnboarding,
  presenter = "general",
  children,
}: ExternalPageProps) => {
  const getPath = (path: string) => `${window.location.pathname === path}`

  const NavComponent = componentMap[presenter]

  return (
    <>
      {presenter !== "none" ? (
        <TopNavBar>
          <NavComponent getPath={getPath} />
        </TopNavBar>
      ) : null}
      <PageWrapper>
        {showOnboarding ? <FirstTimeOnboardingController /> : null}
        <AuthCard>{children}</AuthCard>
      </PageWrapper>
    </>
  )
}

export default ExternalPage
